module.exports = __webpack_public_path__ + "media/images/vk-aff7ad82.svg";